
import { defineComponent } from 'vue';
import * as benchs from '../benchs';
import sampleMd from '../assets/sample';

export default defineComponent({
  name: 'PageJS',
  components: {},
  setup() {
    const start = performance.now();
    let str = '';
    for (let i = 0; i < 1_000_000; i++) {
      const index = Math.floor(Math.random() * 25);
      str = str + 'abcdefghijklmnopqrstuvxyz'.slice(index, index + 1);
    }
    const end = performance.now();
    console.log('generate string: ', end - start);

    const { jsResultTime1, executeJs1 } = benchs.useJsBench1();
    const { jsResultTime2, executeJs2 } = benchs.useJsBench2();
    const { rustResultTime1, executeRust1 } = benchs.useRustBench1();
    const { rustResultTime2, executeRust2 } = benchs.useRustBench2();
    const { rustResultTime3, executeRust3 } = benchs.useRustBench3();
    const { rustResultTime4, executeRust4 } = benchs.useRustBench4();
    const { rustResultTime5, executeRust5 } = benchs.useRustBench5();

    const executeJs1Handler = () => {
      executeJs1(str);
    };

    const executeJs2Handler = () => {
      executeJs2(sampleMd);
    };

    const executeRustHandler1 = () => {
      executeRust1(str);
    };

    const executeRustHandler2 = () => {
      executeRust2(str);
    };

    const executeRustHandler3 = () => {
      executeRust3(sampleMd);
    };

    const executeRustHandler4 = () => {
      executeRust4(sampleMd);
    };

    const executeRustHandler5 = () => {
      executeRust5(sampleMd);
    };

    return {
      jsResultTime1,
      jsResultTime2,
      executeJs1Handler,
      executeJs2Handler,
      executeRustHandler1,
      executeRustHandler2,
      executeRustHandler3,
      executeRustHandler4,
      executeRustHandler5,
      rustResultTime1,
      rustResultTime2,
      rustResultTime3,
      rustResultTime4,
      rustResultTime5,
    };
  },
});
